import { SvgIconProps } from '@mui/material';
import React from 'react';
import info from '../../icons/info-circle.svg';
import { Icon } from './Icon';

/** Circle with i */
export function InfoIcon(props: SvgIconProps) {
  return <Icon glyph={info} {...props} />;
}
